import { render, staticRenderFns } from "./AdminClientTable.vue?vue&type=template&id=558ec0c5&scoped=true"
import script from "./AdminClientTable.vue?vue&type=script&lang=js"
export * from "./AdminClientTable.vue?vue&type=script&lang=js"
import style0 from "./AdminClientTable.vue?vue&type=style&index=0&id=558ec0c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ec0c5",
  null
  
)

export default component.exports